import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowoneway(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.571 5.907a.75.75 0 0 1 1.06.014l5.907 6.07A.75.75 0 0 1 21 13.266H3a.75.75 0 0 1 0-1.5h16.224l-4.667-4.798a.75.75 0 0 1 .014-1.06",
    clipRule: "evenodd"
  }));
}
var IcArrowoneway = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowoneway));

export { IcArrowoneway as I };
